/// <amd-module name="TFS/Admin/Common/RestClient/EnterpriseCatalog" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\webapi\httpclients\clientgeneratorconfigs\enterprisecatalog.genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

export interface IEnterpriseCatalogRestClient extends IVssRestClient {
    /**
     * Generates a CSV file of collection information for each collection that is backed by the tenant  NOTE: The media type in the ClientResponseType header and the media type returned are different. This is an artifact of the framework that we must specify the ClientResponseType header to be stream and the media type type to be Application Octet in order to generate a client with genclient. The actual media type we return in the response "text/event-stream" guarantees a good file download experience
     * 
     * @param tenantId - 
     */
    getCollectionsByTenantId(tenantId: string): Promise<ArrayBuffer>;
}

class EnterpriseCatalogRestClient extends RestClientBase implements IEnterpriseCatalogRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Generates a CSV file of collection information for each collection that is backed by the tenant  NOTE: The media type in the ClientResponseType header and the media type returned are different. This is an artifact of the framework that we must specify the ClientResponseType header to be stream and the media type type to be Application Octet in order to generate a client with genclient. The actual media type we return in the response "text/event-stream" guarantees a good file download experience
     * 
     * @param tenantId - 
     */
    public async getCollectionsByTenantId(
        tenantId: string
        ): Promise<ArrayBuffer> {

        const queryValues: any = {
            tenantId: tenantId
        };

        return this.beginRequest<ArrayBuffer>({
            apiVersion: "5.2-preview.1",
            httpResponseType: "application/octet-stream",
            routeTemplate: "_apis/EnterpriseCatalog/Organizations",
            queryParams: queryValues
        });
    }

}

export const EnterpriseCatalogClientName = "IEnterpriseCatalogRestClient";

export function getEnterpriseCatalogClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IEnterpriseCatalogRestClient {
    return pageContext.getRestClient<IEnterpriseCatalogRestClient>(EnterpriseCatalogClientName, options);
}

RestClients.add(EnterpriseCatalogClientName, { 
    factory: EnterpriseCatalogRestClient,
    options: {
        serviceInstanceType: "00000041-0000-8888-8000-000000000000"
    }
});
